import * as types from '@/constants/mutationTypes'

const state = {
  vendorTags: [],
  vendorTagsFilter: [],
  vendorSearch: '',
  searchType: 'name',
}
const getters = {
  vendorTags: state => state.vendorTags,
  vendorTagsFilter: state => state.vendorTagsFilter,
  vendorSearch: state => state.vendorSearch,
  searchType: state => state.searchType
}
const actions = {
  setVendorTags ({commit}, data) {
    commit(types.SET_VENDOR_TAGS, {data})
  },
  setFilterVendorTag ({commit}, data) {
    commit(types.SET_FILTER_VENDOR_TAGS, {data})
  },
  setSearchVendor ({commit}, data) {
    commit(types.SET_SEARCH_VENDOR, data)
  },
  setTypeSearchVendor ({commit}, data) {
    commit(types.SET_TYPE_SEARCH_VENDOR_TAGS, data)
  },
}
const mutations = {
  [types.SET_TYPE_SEARCH_VENDOR_TAGS] (state, value) {
    state.searchType = value;
  },
  [types.SET_VENDOR_TAGS] (state, {data}) {
    state.vendorTags = data
  },
  [types.SET_FILTER_VENDOR_TAGS] (state, {data}) {
    state.vendorTagsFilter = data
  },
  [types.SET_SEARCH_VENDOR] (state, value) {
    state.vendorSearch = value
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/VendorTags/modules/store.js